import axios, { AxiosInstance, RawAxiosRequestHeaders } from 'axios';

const CONTENT_TYPE_MAP = {
  json: 'application/json',
  form: 'multipart/form-data',
  xml:  'application/xml',
} as const;

type ContentType = keyof typeof CONTENT_TYPE_MAP;
function isContentType(t: any): t is ContentType {
  return typeof t === 'string' && t in CONTENT_TYPE_MAP;
}

export function apiService(
  type?: string,
  extraHeaders: RawAxiosRequestHeaders = {}
): AxiosInstance {
  const key: ContentType = isContentType(type) ? type : 'json';

  const headers: RawAxiosRequestHeaders = {
    'Content-Type': CONTENT_TYPE_MAP[key],
    ...extraHeaders,
  };

  return axios.create({
    baseURL: process.env.REACT_APP_SERVER_BASE_URL ?? '/api',
    withCredentials: true,
    headers,
  });
}

export default apiService;
//     return { success: res.data.success, message: res.data.message };